import { render, staticRenderFns } from "./TasahelUnderReports.vue?vue&type=template&id=c1b2bba4&"
import script from "./TasahelUnderReports.vue?vue&type=script&lang=js&"
export * from "./TasahelUnderReports.vue?vue&type=script&lang=js&"
import style0 from "./TasahelUnderReports.vue?vue&type=style&index=0&id=c1b2bba4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports